import React from 'react';
import VisTimelineView from './components/VisTimelineView';
import { useVisTimelineController, VisTimelineControllerProps } from './hooks/useVisTimelineController';

const VisTimeline: React.FC<VisTimelineControllerProps> = (props) => {
    const ctrl = useVisTimelineController(props);
    return <VisTimelineView {...ctrl} />;
};

export default VisTimeline;
